"use strict";

var _regeneratorRuntime = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator/index.js");
var _classCallCheck = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/createClass.js");
var _assertThisInitialized = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
var _inherits = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EIP1193 = void 0;
var types_1 = require("@web3-react/types");
function parseChainId(chainId) {
  return typeof chainId === 'string' ? Number.parseInt(chainId, 16) : chainId;
}
var EIP1193 = /*#__PURE__*/function (_types_1$Connector) {
  _inherits(EIP1193, _types_1$Connector);
  var _super = _createSuper(EIP1193);
  function EIP1193(_ref) {
    var _this;
    var actions = _ref.actions,
      provider = _ref.provider,
      onError = _ref.onError;
    _classCallCheck(this, EIP1193);
    _this = _super.call(this, actions, onError);
    _this.provider = provider;
    _this.provider.on('connect', function (_ref2) {
      var chainId = _ref2.chainId;
      _this.actions.update({
        chainId: parseChainId(chainId)
      });
    });
    _this.provider.on('disconnect', function (error) {
      var _a;
      _this.actions.resetState();
      (_a = _this.onError) === null || _a === void 0 ? void 0 : _a.call(_assertThisInitialized(_this), error);
    });
    _this.provider.on('chainChanged', function (chainId) {
      _this.actions.update({
        chainId: parseChainId(chainId)
      });
    });
    _this.provider.on('accountsChanged', function (accounts) {
      _this.actions.update({
        accounts: accounts
      });
    });
    return _this;
  }
  _createClass(EIP1193, [{
    key: "activateAccounts",
    value: function activateAccounts(requestAccounts) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cancelActivation, accounts, chainId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cancelActivation = this.actions.startActivation();
              _context.prev = 1;
              _context.next = 4;
              return requestAccounts();
            case 4:
              accounts = _context.sent;
              _context.next = 7;
              return this.provider.request({
                method: 'eth_chainId'
              });
            case 7:
              chainId = _context.sent;
              this.actions.update({
                chainId: parseChainId(chainId),
                accounts: accounts
              });
              _context.next = 15;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              cancelActivation();
              throw _context.t0;
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 11]]);
      }));
    }
    /** {@inheritdoc Connector.connectEagerly} */
  }, {
    key: "connectEagerly",
    value: function connectEagerly() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.activateAccounts(function () {
                return _this2.provider.request({
                  method: 'eth_accounts'
                });
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /** {@inheritdoc Connector.activate} */
  }, {
    key: "activate",
    value: function activate() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.activateAccounts(function () {
                return _this3.provider.request({
                  method: 'eth_requestAccounts'
                }).catch(function () {
                  return _this3.provider.request({
                    method: 'eth_accounts'
                  });
                });
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }]);
  return EIP1193;
}(types_1.Connector);
exports.EIP1193 = EIP1193;